import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MobileBottomNav from '../../components/feature/MobileBottomNav';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

interface CartItem {
  id: number;
  name: string;
  price: number;
  image: string;
  category: string;
  quantity: number;
}

export default function Sepet() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [paymentMethod, setPaymentMethod] = useState<'card' | 'transfer'>('card');
  const [couponCode, setCouponCode] = useState('');

  useEffect(() => {
    loadCart();
  }, []);

  const loadCart = () => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    setCartItems(cart);
  };

  const updateQuantity = (id: number, change: number) => {
    const updatedCart = cartItems.map(item => {
      if (item.id === id) {
        const newQuantity = Math.max(1, item.quantity + change);
        return { ...item, quantity: newQuantity };
      }
      return item;
    });
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
    window.dispatchEvent(new Event('cartUpdated'));
  };

  const removeItem = (id: number) => {
    const updatedCart = cartItems.filter(item => item.id !== id);
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
    window.dispatchEvent(new Event('cartUpdated'));
  };

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = subtotal > 500 ? 0 : 50;
  const total = subtotal + shipping;

  const handleCheckout = () => {
    if (cartItems.length === 0) {
      alert('Sepetiniz boş!');
      return;
    }
    
    if (paymentMethod === 'card') {
      alert('Kredi kartı ödeme sayfasına yönlendiriliyorsunuz...');
    } else {
      alert('Havale bilgileri: \n\nBanka: Örnek Banka\nIBAN: TR00 0000 0000 0000 0000 0000 00\nAlıcı: Hediyatik\n\nÖdeme sonrası WhatsApp ile bildiriniz.');
    }
  };

  if (cartItems.length === 0) {
    return (
      <div className="min-h-screen bg-[#faf9f7]">
        <Navbar />
        <WhatsAppButton />
        
        <div className="pt-32 pb-28 md:pb-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="w-24 h-24 flex items-center justify-center mx-auto mb-6 bg-white rounded-full border border-gray-100">
              <i className="ri-shopping-cart-line text-5xl text-gray-300"></i>
            </div>
            <h1 className="text-3xl font-black font-['Playfair_Display'] text-gray-900 mb-4">
              Sepetiniz Boş
            </h1>
            <p className="text-gray-500 mb-8 text-sm">
              Henüz sepetinize ürün eklemediniz
            </p>
            <button
              onClick={() => navigate('/kategoriler')}
              className="px-8 py-4 bg-gray-900 text-white font-bold rounded-lg hover:bg-gray-800 transition-all whitespace-nowrap text-sm"
            >
              Alışverişe Başla
            </button>
          </div>
        </div>
        
        <Footer />
        <MobileBottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#faf9f7]">
      <Navbar />
      <WhatsAppButton />

      <div className="pt-24 pb-28 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <p className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase mb-1">Alışveriş</p>
            <h1 className="text-4xl font-black font-['Playfair_Display'] text-gray-900">
              SEPETİM
            </h1>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Cart Items */}
            <div className="lg:col-span-2 space-y-4">
              {cartItems.map((item) => (
                <div key={item.id} className="bg-white rounded-xl p-5 border border-gray-100">
                  <div className="flex gap-5">
                    <div className="w-20 h-24 flex-shrink-0 bg-[#f7f5f2] rounded-lg overflow-hidden">
                      <img 
                        src={item.image}
                        alt={item.name}
                        className="w-full h-full object-contain p-2"
                      />
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start mb-1">
                        <div>
                          <p className="text-[10px] text-orange-500 font-bold uppercase tracking-widest mb-1">{item.category}</p>
                          <h3 className="text-sm font-semibold text-gray-900 leading-snug">{item.name}</h3>
                        </div>
                        <button
                          onClick={() => removeItem(item.id)}
                          className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer ml-2"
                          aria-label="Ürünü sil"
                        >
                          <i className="ri-delete-bin-line text-lg"></i>
                        </button>
                      </div>
                      <div className="flex justify-between items-center mt-4">
                        <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
                          <button
                            onClick={() => updateQuantity(item.id, -1)}
                            className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors cursor-pointer rounded"
                          >
                            <i className="ri-subtract-line text-sm"></i>
                          </button>
                          <span className="w-8 text-center text-sm font-bold text-gray-900">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(item.id, 1)}
                            className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors cursor-pointer rounded"
                          >
                            <i className="ri-add-line text-sm"></i>
                          </button>
                        </div>
                        <p className="text-base font-bold text-gray-900">{(item.price * item.quantity).toLocaleString('tr-TR')} ₺</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Order Summary */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl p-6 border border-gray-100 sticky top-24">
                <h2 className="text-lg font-black font-['Playfair_Display'] text-gray-900 mb-6">
                  Sipariş Özeti
                </h2>
                
                <div className="space-y-3 mb-5">
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Ara Toplam</span>
                    <span className="font-semibold text-gray-900">{subtotal.toLocaleString('tr-TR')} ₺</span>
                  </div>
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Kargo</span>
                    <span className="font-semibold text-gray-900">{shipping === 0 ? 'Ücretsiz' : `${shipping} ₺`}</span>
                  </div>
                  {subtotal < 500 && (
                    <p className="text-xs text-green-600 bg-green-50 p-2.5 rounded-lg">
                      500 ₺ üzeri alışverişlerde kargo ücretsiz!
                    </p>
                  )}
                  <div className="border-t border-gray-100 pt-3">
                    <div className="flex justify-between font-black text-gray-900">
                      <span>Toplam</span>
                      <span>{total.toLocaleString('tr-TR')} ₺</span>
                    </div>
                  </div>
                </div>

                {/* Coupon */}
                <div className="mb-5">
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                      placeholder="Kupon Kodu"
                      className="flex-1 px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
                    />
                    <button className="px-4 py-2.5 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-colors whitespace-nowrap text-sm cursor-pointer">
                      Uygula
                    </button>
                  </div>
                </div>

                {/* Payment Method */}
                <div className="mb-5">
                  <h3 className="text-xs font-bold text-gray-900 uppercase tracking-widest mb-3">Ödeme Yöntemi</h3>
                  <div className="space-y-2">
                    <label className="flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer hover:border-orange-300 transition-colors border-gray-100">
                      <input
                        type="radio"
                        name="payment"
                        value="card"
                        checked={paymentMethod === 'card'}
                        onChange={(e) => setPaymentMethod(e.target.value as 'card')}
                        className="accent-orange-500"
                      />
                      <i className="ri-bank-card-line text-lg text-gray-500"></i>
                      <span className="text-sm font-semibold text-gray-800">Kredi Kartı</span>
                    </label>
                    <label className="flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer hover:border-orange-300 transition-colors border-gray-100">
                      <input
                        type="radio"
                        name="payment"
                        value="transfer"
                        checked={paymentMethod === 'transfer'}
                        onChange={(e) => setPaymentMethod(e.target.value as 'transfer')}
                        className="accent-orange-500"
                      />
                      <i className="ri-exchange-line text-lg text-gray-500"></i>
                      <span className="text-sm font-semibold text-gray-800">Havale / EFT</span>
                    </label>
                  </div>
                </div>

                <button
                  onClick={handleCheckout}
                  className="w-full py-4 bg-gray-900 hover:bg-gray-800 text-white font-bold rounded-lg transition-all whitespace-nowrap text-sm tracking-wide cursor-pointer"
                >
                  ÖDEMEYE GEÇ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <MobileBottomNav />
    </div>
  );
}